import { TIME_DEFAULT_START_DATE } from 'Store/constants/sportTypes';

export const TIME_LAST_7_DAYS = new Date() - (7 * 86400000);
export const TIME_LAST_15_DAYS = new Date() - (15 * 86400000);
export const TIME_LAST_1_MONTH = new Date() - (30 * 86400000);
export const TIME_LAST_3_MONTHS = new Date() - (90 * 86400000);
export const TIME_LAST_4_MONTHS = new Date() - (120 * 86400000);
export const TIME_LAST_6_MONTHS = new Date() - (180 * 86400000);
export const TIME_LAST_1_YEAR = new Date() - (365 * 86400000);

export const TIME_ALL = TIME_DEFAULT_START_DATE;

export const EVENTS_API_INTERVAL = 60; // seconds
